export default import.meta.ROLLDOWN_FILE_URL_gV0JVhvBDfrQsRvHxCau5Q